import React, { Component } from 'react'
import { Row, Col, Button, Container } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import { components } from 'react-select';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from 'moment';
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { graphql } from "react-apollo";
import PreloaderTwo from '../preloader/PreloaderTwo';

const FETCH_EDU_STUDENTS = gql`
  query($institute_id: Int,$exam_id:Int,$class_id:Int,$branch_id:Int,$section_id:String) {
    getOfflineStudents(institute_id: $institute_id,exam_id:$exam_id,class_id:$class_id,branch_id:$branch_id,section_id:$section_id) {
      student_name
      student_mobile
      roll_no
    }
  }
`;

class MarksExcelContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }


  render() {
    const getEdustudents = this.props.getEdustudents;
    const loading1 = getEdustudents.loading;
    const error1 = getEdustudents.error;


    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    if (loading1) {
      return (
        <Container>
          <Row>
            <Col sm={12}>
              <div className="spinner-border text-primary text-center loading-img-center">
              </div>
            </Col>
          </Row>
        </Container>)
    }
    let subjectDetails = this.props.stateData.marksArray.sort((a, b) => a.subject_id - b.subject_id);

    console.log("subjectDetails", subjectDetails);
    return (
      <>
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="btn btn-success text-uppercase"
          table="table-to-xls"
          filename="Student_Marks_Sample"
          sheet="Student_Marks_Sample"
          buttonText="View Sample Excel"
        />
        <table id="table-to-xls" style={{ display: "none" }}>
          <thead>
            <tr>
              <th style={{ color: "#000", width: "100px", fontSize: "15px" }} >Student Name</th>
              <th style={{ color: "#000", fontSize: "15px", width: "150px" }} >Student Mobile</th>
              <th style={{ color: "#000", fontSize: "15px", width: "150px" }} >Student Roll No</th>
              {
                subjectDetails.map((item) => {
                  return (
                    <>
                      <th style={{ color: "#000", width: "100px", fontSize: "15px" }} >{item.subject_name}</th>
                    </>
                  )
                })
              }
            </tr>
          </thead>
          <tbody>
            {
              getEdustudents.getOfflineStudents.length > 0 ? (
                getEdustudents.getOfflineStudents.map((item) => {
                  return (
                    <>
                      <tr>
                        <td>{item.student_name}</td>
                        <td>{item.student_mobile}</td>
                        <td>{item.roll_no}</td>
                      </tr>
                    </>
                  )
                })
              ) : ("")
            }
          </tbody>
        </table>
      </>
    )
  }
}


export default withRouter((compose(
  graphql(FETCH_EDU_STUDENTS, {
    options: (props) => ({
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        class_id: parseInt(props.stateData.class),
        exam_id: parseInt(props.stateData.exam),
        section_id: props.stateData.section.toString(),
        branch_id: parseInt(props.stateData.branch),
      },
    }),
    name: "getEdustudents",
  }),
)(MarksExcelContainer))
);




